import React, { Fragment, useState, useEffect } from 'react';
import { Button, Form, Alert, FloatingLabel, Col, Row } from 'react-bootstrap';
import PartidoService from '../../../../services/partido-auth';
import { Link } from 'react-router-dom';
import Moment from 'moment';

const Partido = () => {
    const [ano, setAno] = useState("");
    const [dataCad, setDataCad] = useState("");
    const [error, setError] = useState([]);
    const [arquivo, setArquivo] = useState([]);
    const [sucesso, setSucesso] = useState(false);

    const handleUpload = (e) => setArquivo(e.target.files[0]);


    const montaForm = async () => {
        const partido = new FormData();
        partido.append("ano", ano)
        partido.append("dataCad", dataCad)
        partido.append("arquivo", arquivo);
        return partido
    }

    const HandleSubmit = async (evt) => {
        evt.preventDefault()
        const dados = await montaForm();
        try {
            const partido = await PartidoService.cadastro(dados)
            setSucesso(true)
            setError(false)
        } catch (error) {
            setError(error)
        }
    }

    const addNovo = (evt) => {
        evt.preventDefault()
        setSucesso(false)
        setAno("")
        setDataCad("")
        setArquivo("")
        setError([]);
    }

    if (!sucesso) {
        return (
            <Fragment>
                <Form onSubmit={HandleSubmit} encType="multipart/form-data">
                    <Row xs={1} lg={4}>
                        <Col>
                            <Form.Group className="mb-3" controlId="ano">
                                <FloatingLabel
                                    label="Ano"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="number"
                                        name="ano"
                                        value={ano}
                                        onChange={e => setAno(e.target.value)} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group className="mb-3" controlId="dataCad">
                                <FloatingLabel
                                    label="Data de Lançamento"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="date"
                                        name="dataCad"
                                        value={dataCad}
                                        onChange={e => setDataCad(e.target.value)}
                                    />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row xs={12}>
                        <Col lg={4}>
                            <Form.Group className="mb-3" controlId="arquivo">
                                <Form.Label>Anexo</Form.Label>
                                <Form.Control
                                    required
                                    type="file"
                                    name="arquivo"
                                    onChange={handleUpload}
                                    accept="application/pdf"

                                />
                            </Form.Group>
                        </Col>
                    </Row>
                    {error.length >= 1 ? <Alert variant="danger"> {[...error]}</Alert> : ''}
                    <Button variant="primary" type="submit">
                        Cadastrar
                    </Button>
                </Form >
                <br />
                <Link to={'/restrito/partido'}>
                    <Button variant="danger" type="button">
                        Voltar
                    </Button>
                </Link>
            </Fragment >
        )
    } else {
        return (
            <Fragment>
                <Alert variant='success'>Liberação de Recursos Cadastrada com sucesso!</Alert>
                <Button onClick={addNovo} variant="success" type="submit">
                    Adicionar outro
                </Button>
                <br /><br />
                <Link to={'/restrito/partido/listar'}>
                    <Button variant="primary" type="button">
                        Ir para Listagem de Liberações de Recurso
                    </Button>
                </Link>
                <br /><br />
                <Link to={'/restrito/partido'}>
                    <Button variant="danger" type="button">
                        Voltar
                    </Button>
                </Link>
            </Fragment>
        )
    }
}

export default Partido;